import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Github, Linkedin } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';
import './Footer.css';

const GITHUB_URL = 'https://github.com/Francesco-Mejia';
const LINKEDIN_URL = 'https://www.linkedin.com/in/francesco-mejia-solari-95420333a/';

const Footer: React.FC = () => {
  const { t } = useLanguage();
  const { pathname } = useLocation();
  const year = new Date().getFullYear();

  return (
    <footer className={`footer${pathname === '/' ? ' section-after-curve' : ''}`}>
      <div className="footer-inner editorial-container">
        <div className="footer-brand">
          <Link to="/" className="footer-logo">
            <img
              src={`${process.env.PUBLIC_URL}/soltec-icon.svg`}
              alt=""
              className="footer-logo-icon"
              aria-hidden="true"
            />
            <span className="footer-logo-text">SOLTEC</span>
          </Link>
        </div>

        <div className="footer-links-stack">
          <nav className="footer-nav" aria-label="Footer">
            <Link to="/services">{t.footer.services}</Link>
            <Link to={{ pathname: '/', hash: 'about' }}>{t.footer.about}</Link>
            <Link to={{ pathname: '/', hash: 'contact' }}>{t.footer.contact}</Link>
          </nav>

          <nav className="footer-legal" aria-label="Legal">
            <Link to="/privacy">{t.footer.privacy}</Link>
            <Link to="/security">{t.footer.security}</Link>
            <Link to="/terms">{t.footer.terms}</Link>
          </nav>
        </div>

        <div className="footer-contact">
          <a href="mailto:soltecsoftware@outlook.com" className="footer-email">
            soltecsoftware@outlook.com
          </a>
          <div className="footer-social">
            <a
              href={GITHUB_URL}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="GitHub"
            >
              <Github size={20} strokeWidth={1.75} />
            </a>
            <a
              href={LINKEDIN_URL}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
            >
              <Linkedin size={20} strokeWidth={1.75} />
            </a>
          </div>
        </div>

        <p className="footer-copyright">&copy; {year} Soltec. {t.footer.copyright}</p>
        <p className="footer-location">{t.footer.location}</p>
      </div>
    </footer>
  );
};

export default Footer;
